import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { useSocialIdentity } from "../hooks/Settings/hooks/use-social-identity.js";
import { Settings } from "./Settings.js";
const SettingsContainer = (props) => {
  const intl = useIntl();
  const { data: isSocialIdentity, loading, error } = useSocialIdentity();
  const showPasswordLink = !loading && !isSocialIdentity && !error;
  return /* @__PURE__ */ React.createElement(Settings, { ...props, intl, showPasswordLink });
};
export {
  SettingsContainer as default
};
//# sourceMappingURL=SettingsContainer.js.map
